import { Mail } from "lucide-react";
import { Link, useSearchParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md border-0 shadow-[0_24px_80px_rgba(17,38,43,0.08)]">
        <CardHeader className="text-center">
          <div className="bg-accent/10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <Mail className="text-accent h-8 w-8" />
          </div>
          <CardTitle className="font-heading text-primary text-2xl font-bold">
            Check your email
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted mb-6">
            We&apos;ve sent a verification link to{" "}
            {email ? (
              <span className="text-foreground font-medium">{email}</span>
            ) : (
              "your email address"
            )}
            . Please click the link to verify your account before signing in.
          </p>
          <p className="text-muted mb-6 text-sm">
            Didn&apos;t receive the email? Check your spam folder or try signing up again.
          </p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">Back to sign in</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
